import { useEffect } from 'react';

import { useAuth, useOrganization, useOrganizationList } from '@clerk/react';

interface OrganizationProviderProps {
  children: React.ReactNode;
}

const OrganizationSync = () => {
  const { organization, isLoaded: isOrgLoaded } = useOrganization();
  const { setActive, userMemberships } = useOrganizationList({
    userMemberships: {
      infinite: true
    }
  });

  useEffect(() => {
    if (!isOrgLoaded || organization) {
      return;
    }

    const firstOrg = userMemberships.data?.[0]?.organization;

    if (!firstOrg) {
      console.error(
        '[OrganizationProvider] User has no organizations. Multi-tenancy requires organization membership.'
      );
      return;
    }

    void setActive?.({ organization: firstOrg.id });
  }, [isOrgLoaded, organization, userMemberships.data, setActive]);

  return null;
};

export const OrganizationProvider: React.FC<OrganizationProviderProps> = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();

  return (
    <>
      {isLoaded && isSignedIn && <OrganizationSync />}
      {children}
    </>
  );
};
